import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Content = styled.div`
  width: 100%;
  position: relative;
  height: calc(100% - 143px);
`;

export const Header = styled.div`
  height: 72px;
  width: 100%;

  padding: 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: ${(props) => props.theme.colors?.greys.lightest};
`;

export const HeaderLeftPart = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;

  font: ${(props) => props.theme.fonts.h1InterNonBold};
`;

export const CloseImage = styled.img`
  width: 10px;
  height: 10px;
  cursor: pointer;
`;

export const Footer = styled.div`
  height: 88px;
  width: 100%;

  padding: 24px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  bottom: 0;
  position: absolute;

  border-radius: 0 0 8px 8px;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;
